<style lang="scss">
.slide-22 {
  background-image: url(../../../assets/module1/slide22/background-01.jpg);
  background-position: center;
  background-size: cover;
  padding-left: 50px;
  padding-top: 70px;
  height: calc(100% - 70px);
  h2 {
    font-size: 100px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    span {
      display: block;
      &:last-of-type {
        transform: translate(105px, -15px);
      }
    }
  }
  p {
    margin-bottom: 50px;
    max-width: 640px;
    &.small {
      max-width: 520px;
    }
  }
  h1 {
    color: #3b7fc2;
    font-size: 74px;
    margin-bottom: 60px;
    span {
      display: block;
      transform: rotate(-4deg);
      &:last-of-type {
        transform: rotate(-4deg) translateX(95px);
      }
    }
  }

  h3 {
    color: #edad0a;
    font-size: 74px;
    margin-top: 0;
    margin-bottom: 30px;
    span {
      color: #e30613;
      font-size: 90px;
      transform: translateY(-15px);
    }
  }
  .btn {
    transition: all 0.2s ease-out;
    display: block;
    width: 300px;
    position: absolute;
    left: 675px;
    bottom: 95px;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
  .photocard {
    position: absolute;
    right: 153px;
    top: 37px;
  }
  .crop-wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1.5);
    z-index: 99;
    box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.75);
  }
}
.hidden {
  display: none;
}
</style>

<template>
  <div class="slide-22">
    <transition name="fadeRight" appear>
      <canvas
        v-show="slideIndex == 21"
        ref="canvas"
        class="photocard delay-6"
        width="700"
        height="991"
      ></canvas>
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 21"
        src="@/assets/module1/slide22/timmy-04.png"
        class="chars"
      />
    </transition>
    <transition name="fadeUp" appear>
      <h1
        v-show="slideIndex == 21"
        class="delay-1"
        v-html="$t('module1.slide22.heading')"
      ></h1>
    </transition>
    <transition name="fadeUp" appear>
      <h2
        v-show="slideIndex == 21"
        class="delay-2"
        v-html="$t('module1.slide22.heading2')"
      ></h2>
    </transition>
    <div class="content">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 21" class="delay-3">
          <p class="small">{{ $t("module1.slide22.paragraph") }}</p>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 21" class="delay-4">
          <p>{{ $t("module1.slide22.paragraph2") }}</p>
        </div>
      </transition>
      <ImageCropper
        ref="cropper"
        :crop-aspect-ratio="602 / 550"
        v-on:childToParent="pullImage"
        class="hidden crop-wrap"
      />
      <transition name="scale" appear>
        <a v-show="slideIndex == 21" class="delay-7 btn duration-1"
          ><img
            src="@/assets/module1/slide22/upload_btn.svg"
            @click="uploadClick"
        /></a>
      </transition>
    </div>
    <div class="hidden">
      <img ref="flatImage" id="flatimage" src="" alt="" class="photocard" />
      <canvas ref="print"></canvas>
      <input type="file" ref="file" accept="image/*" @change="updateImage" />
    </div>
  </div>
</template>

<script>
import ImageCropper from "../../../components/ImageCropper.vue";

/**
 * @return {Promise<HTMLImageElement>}
 */
async function loadImage(image) {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.src = image;
  });
}

export default {
  name: "Slide22",
  props: { slideIndex: { type: Number } },
  components: {
    ImageCropper
  },
  data() {
    return {
      croppedImage: "",
      cropShowing: false,
      displayCtx: null,
      printCtx: null,
      photoBackgroundUrl:
        window?.CF_EBOOK_VARS?.documents?.book_1_document_1?.url ||
        require("@/assets/module1/slide22/print_bg.png")
    };
  },
  methods: {
    updateImage(e) {
      const image = new Image();

      image.onload = () => {
        this.displayCtx.drawImage(image, 48, 43, 602, 550);
        /** @type HTMLImageElement */
        const flat = this.$refs.flatImage;

        this.printCtx.drawImage(image, 120, 2602, 1507, 1357);

        if (this.printCtx.canvas.msToBlob) {
          const blob = this.printCtx.canvas.msToBlob();
          this.emitClickFn(() => {
            window.navigator.msSaveBlob(blob, "fast-heroes-poster.jpg");
          });
        } else {
          this.printCtx.canvas.toBlob(blob => {
            flat.src = URL.createObjectURL(blob);
            this.emitBlob(flat.src);
          }, "image/png");
        }
      };

      image.src = e;
    },

    uploadClick() {
      this.cropShowing = true;
      this.$refs.cropper.$el.classList.remove("hidden");
      this.$refs.cropper.showFileChooser();
    },

    pullImage(value) {
      const { cropper } = this.$refs;
      this.croppedImage = value;
      cropper.$el.classList.add("hidden");
      this.updateImage(value);
    },

    /**
     * Passes the blob over for use on the next slide
     * @param blobUrl {string}
     */
    emitBlob(blobUrl) {
      this.$emit("emit-blob", blobUrl);
    },

    /**
     * Passes the blob over for use on the next slide
     * @param handler {function}
     */
    emitClickFn(handler) {
      this.$emit("emit-blob-fn", handler);
    }
  },
  mounted() {
    Promise.all([
      loadImage(require("@/assets/module1/slide22/poster-04.png")).then(
        image => {
          const displayCanvasElement = this.$refs.canvas;
          this.displayCtx = displayCanvasElement.getContext("2d");
          this.displayCtx.drawImage(image, 0, 0, image.width, image.height);
        }
      ),
      loadImage(this.photoBackgroundUrl).then(image => {
        const printCanvasElement = this.$refs.print;
        printCanvasElement.width = image.width;
        printCanvasElement.height = image.height;
        this.printCtx = printCanvasElement.getContext("2d");
        this.printCtx.drawImage(image, 0, 0, image.width, image.height);
      })
    ]);
  }
};
</script>
